import React from "react";
import { MDBInput, MDBBtn } from "mdb-react-ui-kit";
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";

import axios from "axios";
import { INSERT_MENUS } from "../../constants";
import NotificationAlert from "react-notification-alert"; 

var filepath = "";
const AddMenu = (props) => {
  const notificationAlertRef = React.useRef(null);
  const initialsinglemenuState = {
    icon: "",
    name: "",
    displayname: "",
    submenus: [],
  };

  const [singlelayer, setSinglelayer] = React.useState(initialsinglemenuState);

  const submitSignleleyar = () => {
    const resultmenu = {
      filename: filepath,
      name: singlelayer.name,
      icon: singlelayer.icon,
      displayname: singlelayer.displayname,
      submenus: [],
    };
   
    let payload = {
      body: resultmenu,
      // Adding headers to the request
      headers: {
        "Content-type": "application/json;",
      },
    };

    axios
      .post(INSERT_MENUS, resultmenu)
      .then((response) => {
       
        if(response.data.message == "Menu data inserted successfully") {
          let options = {};
          options = {
            place: "tr",
            message: response.data.message,
            type: "success",
            autoDismiss: 3
          };
          notificationAlertRef.current.notificationAlert(options); 
          setTimeout(() => {
            props.btnSub(false);
          }, 1000);          
          
        }else{
          let options = {};
          options = {
            place: "tr",
            message: response.data.message,
            type: "warning",
            autoDismiss: 3
          };
          notificationAlertRef.current.notificationAlert(options);
        }
      })
      .catch((error) => {
       
        let options = {};
        options = {
          place: "tr",
          message:"Fill All Input Fields",
          type: "warning",
          autoDismiss: 3
        };
        notificationAlertRef.current.notificationAlert(options);
        
      });

    
  };

  const changeHandler = (event) => {
    const { name, value } = event.target;

    if (name === "icon") {
      const file = event.target.files[0];
      filepath = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        setSinglelayer({ ...singlelayer, [name]: reader.result });
      };

      reader.onerror = (error) => {
        console.log("Error: ", error);
      };
    } else {
      setSinglelayer({ ...singlelayer, [name]: value });
    }
  };

  return (
    <>
      <Col className="koti" sm="12">
      <NotificationAlert ref={notificationAlertRef} />
        <Row>
          <Col md="4" sm="12">
            <Label>Menu Icon</Label>
            <FormGroup>
              <Input
                placeholder="placeholder"
                type="file"
                id="file"
                style={{
                  opacity: "1",
                  position: "initial",
                  border: "solid 1px #eee",
                }}
                name="icon"
                // value={singlelayer.icon}
                onChange={changeHandler}
              />
            </FormGroup>
          </Col>
          <Col md="4" sm="12" className="mt-4">
            <MDBInput
              label="Menu Name"
              type="text"
              name="name"
              value={singlelayer.name}
              onChange={changeHandler}
            />
          </Col>
          <Col md="4" sm="12" className="mt-4">
            <MDBInput
              label="Menu DisplayName"
              type="text"
              name="displayname"
              value={singlelayer.displayname}
              onChange={changeHandler}
            />
          </Col>

          <Col md="12" sm="12">
            <MDBBtn color="primary" type="button" onClick={submitSignleleyar}>
              Submit
            </MDBBtn>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default AddMenu;
